// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Client Management —— Premium SaaS dashboard —— */
.client-management {
  --cm-font: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --cm-display: 'Poppins', var(--cm-font);
  --cm-ease: 0.2s ease-in-out;
  --cm-primary-from: #4f46e5;
  --cm-primary-mid: #6366f1;
  --cm-primary-to: #7c3aed;
  --cm-surface: #ffffff;
  --cm-text: #111827;
  --cm-text-muted: #1f2937;
  --cm-border-subtle: rgba(226, 232, 240, 0.75);
  --cm-border: #e2e8f0;
  --cm-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 6px 20px rgba(15, 23, 42, 0.05);
  --cm-shadow-hover: 0 8px 28px rgba(15, 23, 42, 0.09), 0 0 0 1px rgba(99, 102, 241, 0.06);
  --cm-shadow-glow: 0 12px 32px rgba(79, 70, 229, 0.22), 0 4px 14px rgba(124, 58, 237, 0.12);
  --cm-radius-card: 16px;
  --cm-radius-pill: 9999px;
  min-height: 100vh;
  background: #ffffff;
  background-image: linear-gradient(180deg, #ffffff 0%, #f1f5f9 55%, #eef2ff 100%);
  padding: clamp(2.5rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 3rem);
  font-family: var(--cm-font);
  font-size: 15px;
  color: var(--cm-text);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

.client-management--detail {
  padding: clamp(2.5rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 3rem);
}

.client-shell {
  max-width: 1280px;
  margin: 0 auto;
}

.client-shell--detail {
  max-width: 800px;
}

/* Header */
.clients-header {
  margin-bottom: clamp(2rem, 4vw, 2.5rem);
  padding-bottom: clamp(1.5rem, 3vw, 2rem);
  border-bottom: 1px solid var(--cm-border-subtle);
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--cm-primary-mid);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.5rem 0.875rem;
  border-radius: var(--cm-radius-pill);
  background: rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.15);
  transition: transform var(--cm-ease), background var(--cm-ease), box-shadow var(--cm-ease);
}

.back-link:hover {
  background: rgba(99, 102, 241, 0.16);
  transform: translateX(-2px);
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.15);
}

.page-intro {
  width: 100%;
}

.page-title {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.title-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--cm-primary-from), var(--cm-primary-to));
  color: #fff;
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.35);
}

.title-icon {
  font-size: 1.25rem;
}

.page-title-text h1 {
  font-family: var(--cm-display);
  font-size: clamp(1.625rem, 2.6vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--cm-text);
  margin: 0 0 0.375rem 0;
  line-height: 1.25;
}

.page-subtitle {
  margin: 0;
  font-size: 0.9375rem;
  color: #111827;
  font-weight: 500;
  line-height: 1.55;
  max-width: 36rem;
}

/* Search */
.filters-section {
  margin-bottom: clamp(2rem, 4vw, 2.75rem);
  padding-top: 0.25rem;
}

.search-box {
  position: relative;
  max-width: 420px;
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.95rem;
  pointer-events: none;
}

.search-box input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 2.75rem;
  border: 1px solid var(--cm-border);
  border-radius: var(--cm-radius-pill);
  font-size: 0.9375rem;
  font-family: inherit;
  background: var(--cm-surface);
  color: var(--cm-text);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color var(--cm-ease), box-shadow var(--cm-ease);
}

.search-box input::placeholder {
  color: #94a3b8;
}

.search-box input:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.45);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

/* Grid: 3 columns desktop, spacious gap */
.clients-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(24px, 2.8vw, 32px);
  margin-bottom: clamp(2.5rem, 4vw, 3.5rem);
}

@media (min-width: 640px) {
  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1100px) {
  .clients-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@keyframes cm-card-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.client-card {
  position: relative;
  background: var(--cm-surface);
  border-radius: var(--cm-radius-card);
  padding: clamp(20px, 2.2vw, 24px);
  box-shadow: var(--cm-shadow);
  border: 1px solid var(--cm-border);
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 0;
  animation: cm-card-in 0.55s cubic-bezier(0.22, 1, 0.36, 1) backwards;
  transition: transform var(--cm-ease), box-shadow var(--cm-ease), border-color var(--cm-ease);
}

.client-card:hover {
  transform: scale(1.02);
  box-shadow: var(--cm-shadow-hover);
  border-color: rgba(99, 102, 241, 0.18);
}

.client-card:focus-within {
  outline: none;
  box-shadow: var(--cm-shadow-hover), 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: clamp(12px, 2vw, 16px);
  padding-bottom: clamp(12px, 2vw, 16px);
  border-bottom: 1px solid var(--cm-border-subtle);
}

.client-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--cm-primary-from) 0%, var(--cm-primary-to) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.3);
}

.client-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.client-basic-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 1.5vw, 14px);
}

.client-name {
  font-family: var(--cm-display);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--cm-text);
  margin: 0;
  line-height: 1.35;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.client-email-line {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #111827;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.client-email-line--muted {
  color: #374151;
  font-style: italic;
}

.client-role-pill {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 0;
  padding: 0.2rem 0.65rem;
  border-radius: var(--cm-radius-pill);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #4338ca;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(124, 58, 237, 0.1));
  border: 1px solid rgba(99, 102, 241, 0.2);
}

/* Legacy badges (forms / other) */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: #c6f6d5;
  color: #22543d;
}

.status-badge.inactive {
  background: #fed7d7;
  color: #742a2a;
}

.status-badge.ACCEPTED {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(124, 58, 237, 0.1));
  color: #4338ca;
}

.card-meta {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 1.8vw, 16px);
  margin-bottom: clamp(14px, 2vw, 18px);
  flex: 1 1;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 36px;
}

.meta-row-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(99, 102, 241, 0.08);
  color: var(--cm-primary-mid);
  font-size: 0.8rem;
}

.meta-row-text {
  flex: 1 1;
  min-width: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #111827;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.client-card-cta {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: auto;
  padding: 0.8125rem 1.25rem;
  border: none;
  border-radius: var(--cm-radius-pill);
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(115deg, var(--cm-primary-from) 0%, var(--cm-primary-mid) 45%, var(--cm-primary-to) 100%);
  background-size: 115% 100%;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.28);
  transition: transform var(--cm-ease), box-shadow var(--cm-ease), filter var(--cm-ease),
    background-position 0.35s ease-in-out;
}

.client-card-cta:hover {
  transform: translateY(-2px) scale(1.01);
  background-position: 95% 0;
  box-shadow: var(--cm-shadow-glow);
  filter: brightness(1.06);
}

.client-card-cta:active {
  transform: translateY(0) scale(0.99);
}

.client-card-cta-chevron {
  font-size: 0.75rem;
  opacity: 0.9;
  margin-left: 0.125rem;
}

/* Card internals no longer use old stat rows */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.profile-contact {
  margin-top: 0.5rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  color: #111827;
  font-size: 0.875rem;
}

.contact-item .meta-icon {
  color: var(--cm-primary-mid);
  flex-shrink: 0;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 3rem 1.5rem;
  background: var(--cm-surface);
  border-radius: var(--cm-radius-card);
  border: 1px solid var(--cm-border);
  box-shadow: var(--cm-shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: cm-card-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) backwards;
}

.empty-state-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(124, 58, 237, 0.08));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.empty-icon {
  font-size: 1.75rem;
  color: var(--cm-primary-mid);
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--cm-text);
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}

.empty-state p {
  color: #111827;
  margin: 0;
  font-size: 0.9375rem;
  max-width: 22rem;
  line-height: 1.55;
}

.add-first-client-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, var(--cm-primary-from), var(--cm-primary-to));
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.add-first-client-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

/* Loading State */
.clients-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: var(--cm-text-muted);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid var(--cm-primary-mid);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Client Detail View */
.client-detail {
  background: #ffffff;
  border-radius: var(--cm-radius-card);
  padding: clamp(1.25rem, 3vw, 2rem);
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.1);
  border: 1px solid #c7d2e0;
}

.detail-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid var(--cm-border-subtle);
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #f1f5f9;
  color: #111827;
  border: 1px solid var(--cm-border);
  padding: 0.625rem 1rem;
  border-radius: var(--cm-radius-pill);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.back-btn:hover {
  background: #e2e8f0;
  color: #111827;
  transform: translateX(-2px);
}

.client-actions {
  display: flex;
  gap: 12px;
}

.client-profile {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.profile-header {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
}

.client-avatar-large {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--cm-primary-from), var(--cm-primary-to));
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.35);
}

.client-avatar-large img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.profile-info {
  flex: 1 1;
  min-width: 0;
}

.profile-info h1 {
  font-family: var(--cm-display);
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--cm-text);
  margin: 0 0 0.5rem 0;
  line-height: 1.35;
}

.client-status {
  margin: 0;
}

.profile-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
}

.stat-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.125rem 1.25rem;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #c7d2e0;
  transition: box-shadow 0.2s ease;
}

.stat-item:hover {
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
}

.stat-item-icon {
  font-size: 1.25rem;
  color: var(--cm-primary-mid);
  margin-top: 0.125rem;
}

.stat-item-label {
  margin: 0 0 0.25rem 0;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #111827;
}

.stat-item-value {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
}

.profile-sections {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.section {
  padding: 1.25rem 1.375rem;
  border-radius: 14px;
  border: 1px solid #c7d2e0;
  background: #ffffff;
}

.section--elevated {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.section h3 {
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #111827;
  margin: 0 0 1rem 0;
}

.section p {
  color: #111827;
  line-height: 1.6;
  margin: 0;
}

.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.session-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.125rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #c7d2e0;
}

.session-item--row {
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

.session-item-leading {
  flex-shrink: 0;
  margin-top: 0.25rem;
  font-size: 1rem;
  color: var(--cm-primary-mid);
}

.session-info h4 {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #111827;
  margin: 0 0 0.35rem 0;
}

.session-info p {
  color: #111827;
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 500;
}

.session-stats {
  display: flex;
  gap: 15px;
  color: #111827;
  font-size: 0.9rem;
}

.session-status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.session-status.completed {
  background: #c6f6d5;
  color: #22543d;
}

.session-status.pending {
  background: #fef5e7;
  color: #c05621;
}

.session-status.in-progress {
  background: #bee3f8;
  color: #2a4365;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #a0aec0;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #f7fafc;
  color: #4a5568;
}

.add-client-form {
  padding: 30px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.modal-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.cancel-btn {
  padding: 12px 24px;
  background: #f7fafc;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #edf2f7;
  color: #2d3748;
}

.save-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}


.filter-dropdown {
  position: relative;
  min-width: 150px;
}

.filter-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 1rem;
  z-index: 1;
}

.filter-dropdown select {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-dropdown select:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.add-client-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.add-client-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  justify-content: center;
  min-width: 80px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn.view {
  background: #dbeafe;
  color: #1e40af;
}

.action-btn.edit {
  background: #fef5e7;
  color: #c05621;
}

.action-btn.gallery {
  background: #e6fffa;
  color: #234e52;
}

.action-btn.barcode {
  background: #f0fff4;
  color: #22543d;
}

.action-btn.delete {
  background: #fed7d7;
  color: #742a2a;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive Design */
@media (max-width: 639px) {
  .clients-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .profile-info .contact-info,
  .client-status {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .profile-contact .contact-item {
    justify-content: center;
    color: #111827;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .client-management {
    padding: clamp(1.25rem, 5vw, 2.5rem) clamp(1rem, 4vw, 1.5rem);
  }

  .client-management--detail {
    padding: clamp(1.25rem, 5vw, 2.5rem) clamp(1rem, 4vw, 1.5rem);
  }

  .client-card {
    padding: clamp(18px, 4vw, 22px);
  }

  .modal-content {
    margin: 10px;
  }

  .modal-header,
  .add-client-form {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/ClientManagement.css"],"names":[],"mappings":"AAEA,sDAAsD;AACtD;EACE,4EAA4E;EAC5E,uCAAuC;EACvC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,6CAA6C;EAC7C,oBAAoB;EACpB,gFAAgF;EAChF,wFAAwF;EACxF,0FAA0F;EAC1F,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,gFAAgF;EAChF,6DAA6D;EAC7D,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,uCAAuC;EACvC,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,oCAAoC;EACpC,mCAAmC;EACnC,0CAA0C;EAC1C,0FAA0F;AAC5F;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iFAAiF;EACjF,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,kCAAkC;EAClC,oCAAoC;EACpC,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,4CAA4C;EAC5C,kEAAkE;AACpE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,0BAA0B;EAC1B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,oEAAoE;EACpE,4FAA4F;AAC9F;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yFAAyF;EACzF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sFAAsF;EACtF,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;EACrC,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oHAAoH;EACpH,0BAA0B;EAC1B,8CAA8C;EAC9C;yCACuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iFAAiF;EACjF,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,uBAAuB;EACvB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@600;700&display=swap');\n\n/* —— Client Management —— Premium SaaS dashboard —— */\n.client-management {\n  --cm-font: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;\n  --cm-display: 'Poppins', var(--cm-font);\n  --cm-ease: 0.2s ease-in-out;\n  --cm-primary-from: #4f46e5;\n  --cm-primary-mid: #6366f1;\n  --cm-primary-to: #7c3aed;\n  --cm-surface: #ffffff;\n  --cm-text: #111827;\n  --cm-text-muted: #1f2937;\n  --cm-border-subtle: rgba(226, 232, 240, 0.75);\n  --cm-border: #e2e8f0;\n  --cm-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 6px 20px rgba(15, 23, 42, 0.05);\n  --cm-shadow-hover: 0 8px 28px rgba(15, 23, 42, 0.09), 0 0 0 1px rgba(99, 102, 241, 0.06);\n  --cm-shadow-glow: 0 12px 32px rgba(79, 70, 229, 0.22), 0 4px 14px rgba(124, 58, 237, 0.12);\n  --cm-radius-card: 16px;\n  --cm-radius-pill: 9999px;\n  min-height: 100vh;\n  background: #ffffff;\n  background-image: linear-gradient(180deg, #ffffff 0%, #f1f5f9 55%, #eef2ff 100%);\n  padding: clamp(2.5rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 3rem);\n  font-family: var(--cm-font);\n  font-size: 15px;\n  color: var(--cm-text);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n.client-management--detail {\n  padding: clamp(2.5rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 3rem);\n}\n\n.client-shell {\n  max-width: 1280px;\n  margin: 0 auto;\n}\n\n.client-shell--detail {\n  max-width: 800px;\n}\n\n/* Header */\n.clients-header {\n  margin-bottom: clamp(2rem, 4vw, 2.5rem);\n  padding-bottom: clamp(1.5rem, 3vw, 2rem);\n  border-bottom: 1px solid var(--cm-border-subtle);\n}\n\n.header-left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1.25rem;\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--cm-primary-mid);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.875rem;\n  padding: 0.5rem 0.875rem;\n  border-radius: var(--cm-radius-pill);\n  background: rgba(99, 102, 241, 0.1);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  transition: transform var(--cm-ease), background var(--cm-ease), box-shadow var(--cm-ease);\n}\n\n.back-link:hover {\n  background: rgba(99, 102, 241, 0.16);\n  transform: translateX(-2px);\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.15);\n}\n\n.page-intro {\n  width: 100%;\n}\n\n.page-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.title-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, var(--cm-primary-from), var(--cm-primary-to));\n  color: #fff;\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.35);\n}\n\n.title-icon {\n  font-size: 1.25rem;\n}\n\n.page-title-text h1 {\n  font-family: var(--cm-display);\n  font-size: clamp(1.625rem, 2.6vw, 2rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--cm-text);\n  margin: 0 0 0.375rem 0;\n  line-height: 1.25;\n}\n\n.page-subtitle {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: #111827;\n  font-weight: 500;\n  line-height: 1.55;\n  max-width: 36rem;\n}\n\n/* Search */\n.filters-section {\n  margin-bottom: clamp(2rem, 4vw, 2.75rem);\n  padding-top: 0.25rem;\n}\n\n.search-box {\n  position: relative;\n  max-width: 420px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  font-size: 0.95rem;\n  pointer-events: none;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 0.875rem 1rem 0.875rem 2.75rem;\n  border: 1px solid var(--cm-border);\n  border-radius: var(--cm-radius-pill);\n  font-size: 0.9375rem;\n  font-family: inherit;\n  background: var(--cm-surface);\n  color: var(--cm-text);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color var(--cm-ease), box-shadow var(--cm-ease);\n}\n\n.search-box input::placeholder {\n  color: #94a3b8;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: rgba(99, 102, 241, 0.45);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n/* Grid: 3 columns desktop, spacious gap */\n.clients-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(24px, 2.8vw, 32px);\n  margin-bottom: clamp(2.5rem, 4vw, 3.5rem);\n}\n\n@media (min-width: 640px) {\n  .clients-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1100px) {\n  .clients-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@keyframes cm-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.client-card {\n  position: relative;\n  background: var(--cm-surface);\n  border-radius: var(--cm-radius-card);\n  padding: clamp(20px, 2.2vw, 24px);\n  box-shadow: var(--cm-shadow);\n  border: 1px solid var(--cm-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 0;\n  animation: cm-card-in 0.55s cubic-bezier(0.22, 1, 0.36, 1) backwards;\n  transition: transform var(--cm-ease), box-shadow var(--cm-ease), border-color var(--cm-ease);\n}\n\n.client-card:hover {\n  transform: scale(1.02);\n  box-shadow: var(--cm-shadow-hover);\n  border-color: rgba(99, 102, 241, 0.18);\n}\n\n.client-card:focus-within {\n  outline: none;\n  box-shadow: var(--cm-shadow-hover), 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: clamp(12px, 2vw, 16px);\n  padding-bottom: clamp(12px, 2vw, 16px);\n  border-bottom: 1px solid var(--cm-border-subtle);\n}\n\n.client-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: linear-gradient(145deg, var(--cm-primary-from) 0%, var(--cm-primary-to) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.3);\n}\n\n.client-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.client-basic-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(10px, 1.5vw, 14px);\n}\n\n.client-name {\n  font-family: var(--cm-display);\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--cm-text);\n  margin: 0;\n  line-height: 1.35;\n  letter-spacing: -0.02em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.client-email-line {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #111827;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.client-email-line--muted {\n  color: #374151;\n  font-style: italic;\n}\n\n.client-role-pill {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  margin-top: 0;\n  padding: 0.2rem 0.65rem;\n  border-radius: var(--cm-radius-pill);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #4338ca;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(124, 58, 237, 0.1));\n  border: 1px solid rgba(99, 102, 241, 0.2);\n}\n\n/* Legacy badges (forms / other) */\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.active {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.status-badge.inactive {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.status-badge.ACCEPTED {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(124, 58, 237, 0.1));\n  color: #4338ca;\n}\n\n.card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(12px, 1.8vw, 16px);\n  margin-bottom: clamp(14px, 2vw, 18px);\n  flex: 1;\n}\n\n.meta-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 36px;\n}\n\n.meta-row-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: rgba(99, 102, 241, 0.08);\n  color: var(--cm-primary-mid);\n  font-size: 0.8rem;\n}\n\n.meta-row-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #111827;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.client-card-cta {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: auto;\n  padding: 0.8125rem 1.25rem;\n  border: none;\n  border-radius: var(--cm-radius-pill);\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  background: linear-gradient(115deg, var(--cm-primary-from) 0%, var(--cm-primary-mid) 45%, var(--cm-primary-to) 100%);\n  background-size: 115% 100%;\n  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.28);\n  transition: transform var(--cm-ease), box-shadow var(--cm-ease), filter var(--cm-ease),\n    background-position 0.35s ease-in-out;\n}\n\n.client-card-cta:hover {\n  transform: translateY(-2px) scale(1.01);\n  background-position: 95% 0;\n  box-shadow: var(--cm-shadow-glow);\n  filter: brightness(1.06);\n}\n\n.client-card-cta:active {\n  transform: translateY(0) scale(0.99);\n}\n\n.client-card-cta-chevron {\n  font-size: 0.75rem;\n  opacity: 0.9;\n  margin-left: 0.125rem;\n}\n\n/* Card internals no longer use old stat rows */\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.profile-contact {\n  margin-top: 0.5rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  color: #111827;\n  font-size: 0.875rem;\n}\n\n.contact-item .meta-icon {\n  color: var(--cm-primary-mid);\n  flex-shrink: 0;\n}\n\n/* Empty state */\n.empty-state {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  background: var(--cm-surface);\n  border-radius: var(--cm-radius-card);\n  border: 1px solid var(--cm-border);\n  box-shadow: var(--cm-shadow);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  animation: cm-card-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) backwards;\n}\n\n.empty-state-icon-wrap {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(124, 58, 237, 0.08));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n}\n\n.empty-icon {\n  font-size: 1.75rem;\n  color: var(--cm-primary-mid);\n}\n\n.empty-state h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--cm-text);\n  margin: 0 0 0.5rem 0;\n  letter-spacing: -0.02em;\n}\n\n.empty-state p {\n  color: #111827;\n  margin: 0;\n  font-size: 0.9375rem;\n  max-width: 22rem;\n  line-height: 1.55;\n}\n\n.add-first-client-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, var(--cm-primary-from), var(--cm-primary-to));\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.add-first-client-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n/* Loading State */\n.clients-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: var(--cm-text-muted);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid var(--cm-primary-mid);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Client Detail View */\n.client-detail {\n  background: #ffffff;\n  border-radius: var(--cm-radius-card);\n  padding: clamp(1.25rem, 3vw, 2rem);\n  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.1);\n  border: 1px solid #c7d2e0;\n}\n\n.detail-header {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid var(--cm-border-subtle);\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #f1f5f9;\n  color: #111827;\n  border: 1px solid var(--cm-border);\n  padding: 0.625rem 1rem;\n  border-radius: var(--cm-radius-pill);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;\n}\n\n.back-btn:hover {\n  background: #e2e8f0;\n  color: #111827;\n  transform: translateX(-2px);\n}\n\n.client-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.client-profile {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n\n.profile-header {\n  display: flex;\n  gap: 1.25rem;\n  align-items: flex-start;\n}\n\n.client-avatar-large {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(145deg, var(--cm-primary-from), var(--cm-primary-to));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.35);\n}\n\n.client-avatar-large img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.profile-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.profile-info h1 {\n  font-family: var(--cm-display);\n  font-size: clamp(1.25rem, 2vw, 1.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--cm-text);\n  margin: 0 0 0.5rem 0;\n  line-height: 1.35;\n}\n\n.client-status {\n  margin: 0;\n}\n\n.profile-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 1rem;\n}\n\n.stat-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.125rem 1.25rem;\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #c7d2e0;\n  transition: box-shadow 0.2s ease;\n}\n\n.stat-item:hover {\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);\n}\n\n.stat-item-icon {\n  font-size: 1.25rem;\n  color: var(--cm-primary-mid);\n  margin-top: 0.125rem;\n}\n\n.stat-item-label {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #111827;\n}\n\n.stat-item-value {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.profile-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.section {\n  padding: 1.25rem 1.375rem;\n  border-radius: 14px;\n  border: 1px solid #c7d2e0;\n  background: #ffffff;\n}\n\n.section--elevated {\n  background: #ffffff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n}\n\n.section h3 {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #111827;\n  margin: 0 0 1rem 0;\n}\n\n.section p {\n  color: #111827;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.sessions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.session-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.125rem;\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #c7d2e0;\n}\n\n.session-item--row {\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.session-item-leading {\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n  font-size: 1rem;\n  color: var(--cm-primary-mid);\n}\n\n.session-info h4 {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #111827;\n  margin: 0 0 0.35rem 0;\n}\n\n.session-info p {\n  color: #111827;\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 500;\n}\n\n.session-stats {\n  display: flex;\n  gap: 15px;\n  color: #111827;\n  font-size: 0.9rem;\n}\n\n.session-status {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.session-status.completed {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.session-status.pending {\n  background: #fef5e7;\n  color: #c05621;\n}\n\n.session-status.in-progress {\n  background: #bee3f8;\n  color: #2a4365;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px 30px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.add-client-form {\n  padding: 30px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.cancel-btn {\n  padding: 12px 24px;\n  background: #f7fafc;\n  color: #4a5568;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.save-btn {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n\n.filter-dropdown {\n  position: relative;\n  min-width: 150px;\n}\n\n.filter-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0;\n  font-size: 1rem;\n  z-index: 1;\n}\n\n.filter-dropdown select {\n  width: 100%;\n  padding: 12px 15px 12px 45px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.filter-dropdown select:focus {\n  outline: none;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.add-client-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.add-client-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex: 1;\n  justify-content: center;\n  min-width: 80px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.action-btn.view {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.action-btn.edit {\n  background: #fef5e7;\n  color: #c05621;\n}\n\n.action-btn.gallery {\n  background: #e6fffa;\n  color: #234e52;\n}\n\n.action-btn.barcode {\n  background: #f0fff4;\n  color: #22543d;\n}\n\n.action-btn.delete {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive Design */\n@media (max-width: 639px) {\n  .clients-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .profile-info .contact-info,\n  .client-status {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .profile-contact .contact-item {\n    justify-content: center;\n    color: #111827;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .client-management {\n    padding: clamp(1.25rem, 5vw, 2.5rem) clamp(1rem, 4vw, 1.5rem);\n  }\n\n  .client-management--detail {\n    padding: clamp(1.25rem, 5vw, 2.5rem) clamp(1rem, 4vw, 1.5rem);\n  }\n\n  .client-card {\n    padding: clamp(18px, 4vw, 22px);\n  }\n\n  .modal-content {\n    margin: 10px;\n  }\n\n  .modal-header,\n  .add-client-form {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
